<template>
  <div>
    <div v-if="!remoteData || !remoteData.patientList || remoteData.patientList.length === 0">
      <md-skeleton avatar title :loading="remoteDataLoading" :row="8">
        <md-field>
          <md-cell-item>无数据</md-cell-item>
          <md-cell-item v-if="this.remoteError">{{this.remoteError}}</md-cell-item>
        </md-field>
      </md-skeleton>
    </div>
    <div v-else>
      <md-field>
        <md-cell-item v-for="item of remoteData.patientList" :key="item.id" :title="item.name" :brief="'证件号：'+item.credentialNo" arrow @click="onItemClick(item.id)">
          <span class="holder" slot="left">{{item.name[0]}}</span>
        </md-cell-item>
      </md-field>
    </div>

    <md-dialog title="就诊人" :closable="true"  v-model="isPatientDialogShow" :btns="patientDialogBtns" mask-closable>
      <md-input-item title="*姓名" placeholder="就诊人姓名" v-model="patient.name" type="text" @blur="onBlur" clearable/>
      <md-field-item title="*证件类型" solid>
        <md-radio :name="credentialTypeOptions[0].value" v-model="patient.credentialType" :label="credentialTypeOptions[0].text" />
        <md-radio :name="credentialTypeOptions[1].value" v-model="patient.credentialType" :label="credentialTypeOptions[1].text" />
        <md-radio :name="credentialTypeOptions[2].value" v-model="patient.credentialType" :label="credentialTypeOptions[2].text" />
      </md-field-item>
      <md-input-item title="*证件号" placeholder="就诊人证件号" v-model="patient.credentialNo" type="text" @blur="onBlurCredentialNo" clearable v-show="!isParentNameShow"/>
      <md-input-item title="*母亲姓名" placeholder="就诊人母亲的姓名" v-model="patient.parentsName" type="text" @blur="onBlur" clearable v-show="isParentNameShow"/>

      <md-field-item title="*生日" solid align="left" :content="formatDate(new Date(patient.birthday), 'yyyy-MM-dd')" @click.native="onBirthdayClick" arrow="arrow-right">
      </md-field-item>
      <md-field-item solid title="*性别">
        <md-radio name="男" v-model="patient.sex" label="男" inline />
        <md-radio name="女" v-model="patient.sex" label="女" inline />
      </md-field-item>

      <md-input-item title="手机" placeholder="能联系到就诊人的手机号码" v-model="patient.phone" type="phone" @blur="onBlur" clearable/>

      <md-date-picker
        ref="datePicker"
        v-model="isDatePickerShow"
        type="custom"
        title="选择日期"
        large-radius
        :custom-types="['yyyy', 'MM','dd']"
        :default-date="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        @change="onDatePickerChange"
        @confirm="onDatePickerConfirm"
      ></md-date-picker>
    </md-dialog>

  </div>
</template>

<script>
import { patientList, patientUpdate, patientDelete } from '../api/daSetting'
import { Toast, Field, CellItem, Skeleton, Dialog, InputItem, FieldItem, Radio, Selector, DatePicker } from 'mand-mobile'
import { isEmpty, formatDate } from '@utils/func'
import idCode from '@utils/idCode'

export default {
  name: 'PatientList',
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Skeleton.name]: Skeleton,
    [Dialog.name]: Dialog,
    [InputItem.name]: InputItem,
    [FieldItem.name]: FieldItem,
    [Radio.name]: Radio,
    [Selector.name]: Selector,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      remoteData: [],
      remoteDataLoading: false,
      remoteError: null,
      isDatePickerShow: false,
      isParentNameShow: false,
      currentDate: new Date('2010-01-01'),
      minDate: new Date('1920-01-01'),
      maxDate: new Date(),
      isSelectorShow: false,
      isPatientDialogShow: false,
      patient: {
        id: null, name: '', birthday: null, sex: '', credentialType: 'id_card', credentialNo: '', phone: '', parentsName: ''
      },
      // TODO 从后台获取列表
      credentialTypeOptions: [
        { text: '身份证', value: 'id_card' },
        { text: '未办理身份证', value: 'none' },
        { text: '其它证件', value: 'other' }
      ],
      patientDialogBtns: [
        {
          text: '删除',
          handler: this.onPatientDelete,
          warning: true
        },
        {
          text: '保存',
          handler: this.onPatientSave
        }
      ]
    }
  },
  watch: {
    'patient.credentialType': {
      handler(val, oldVal) {
        if (isEmpty(val)) {
          return
        }
        if (val === 'none') {
          this.isParentNameShow = true
          this.patient.credentialNo = ''
        } else {
          this.isParentNameShow = false
          this.patient.parentsName = ''
        }
      }
    }
  },
  created () {
    this.loadRemoteData()
  },
  methods: {
    formatDate,
    loadRemoteData () {
      this.remoteDataLoading = true
      this.remoteError = null
      this.remoteData = []
      patientList().then(res => {
        this.remoteDataLoading = false
        if (res.data && res.status === 200) {
          this.remoteData = res.data
        } else {
          this.remoteError = res.msg
        }
      }).catch(err => {
        this.remoteDataLoading = false
        this.remoteError = err
        console.log('patientList.err=', err)
      })
    },
    onBirthdayClick() {
      //this.currentDate = new Date(this.patient.birthday)
      console.log(this.currentDate)
      this.isDatePickerShow = true
    },
    onBlur() {
      window.scrollTo(0, document.documentElement.scrollTop || document.body.scrollTop)
    },
    onDatePickerChange(columnIndex, itemIndex, value) {
      //this.patient.birthday = this.$refs.datePicker.getFormatDate('yyyy-MM-dd')
      //console.log(this.patient.birthday)
    },
    onDatePickerConfirm(columnsValue) {
      this.patient.birthday = this.$refs.datePicker.getFormatDate('yyyy-MM-dd')
      console.log(columnsValue)
    },
    onBlurCredentialNo() {
      this.onBlur()
      // 验证身份证
      if (this.patient.credentialType === 'id_card') {
        const obj = idCode.createNew(this.patient.credentialNo)
        if (!obj.isCheck()) {
          Dialog.alert({
            title: '错误',
            content: '身份证填写错误'
          })
          return
        }
        const sex = obj.getGender()
        this.patient.sex = sex
        this.patient.birthday = obj.getYears() + '-' + obj.getMonth() + '-' + obj.getDay()
        this.currentDate = new Date(this.patient.birthday)
      }
    },
    onItemClick (patientId) {
      if (this.remoteData.patientList) {
        for (let i = 0; i < this.remoteData.patientList.length; ++i) {
          if (this.remoteData.patientList[i].id === patientId) {
            this.patient = { ...this.remoteData.patientList[i] }
            this.isPatientDialogShow = true
            return
          }
        }
      }
    },
    onPatientDelete () {
      Toast.loading('waiting')
      patientDelete(this.patient.id).then(res => {
        Toast.hide()
        this.isPatientDialogShow = false
        this.loadRemoteData()
      }).catch(err => {
        Toast.hide()
        Toast.info('错误：' + err)
      })
    },
    onPatientSave () {
      if (isEmpty(this.patient.name)) {
        Toast.info('请填写就诊人姓名')
        return
      }
      if (this.patient.name.length < 2) {
        Toast.info('就诊人姓名长度不够')
        return
      }
      if (this.patient.credentialType === 'id_card') {
        if (!idCode.createNew(this.patient.credentialNo).isCheck()) {
          Toast.info('二代身份证号填写错误')
          return
        }
      } else if (this.patient.credentialType === 'other') {
        if (isEmpty(this.patient.credentialNo) || this.patient.credentialNo.length < 6) {
          Toast.info('证件号错误，长度至少6位')
          return
        }
      }
      if (isEmpty(this.patient.sex)) {
        Toast.info('请选择就诊人性别')
        return
      }
      if (isEmpty(this.patient.birthday)) {
        Toast.info('请设置就诊人生日')
        return
      }
      if (this.patient.credentialType === 'none') {
        if (isEmpty(this.patient.parentsName)) {
          Toast.info('请输入就诊人母亲的姓名')
          return
        }
        // 没有身份证的就诊人，使用其生日填充
        this.patient.credentialNo = formatDate(new Date(this.patient.birthday), 'yyyyMMdd')
      }

      Toast.loading('waiting')
      patientUpdate(this.patient).then(res => {
        Toast.hide()
        this.isPatientDialogShow = false
        this.loadRemoteData()
      }).catch(err => {
        Toast.hide()
        Dialog.failed({
          title: '失败',
          confirmText: '知道了',
          content: (err.msg || err)
        })
      })
    }
  }
}
</script>
